import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { DELETE_NOTIFICATION_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const useDeleteNotification = ({ onSuccess, onError, uuid }: Input) => {
  const deleteNotification = async (notificationType: string) => {
    await axiosClient.delete<void>(DELETE_NOTIFICATION_URL(uuid), {
      data: {
        notificationType,
      },
    });
  };

  return useCustomMutation(deleteNotification, {
    onSuccess,
    onError,
  });
};
